import { forwardRef } from 'react';
import MagicButtonIcon from 'assets/icons/magic-button.svg';
import WhiteCloseIcon from 'assets/icons/close-white.svg';

interface ChatbotFloatingButtonProps {
  onClick: () => void;
  isOpen: boolean;
}

const ChatbotFloatingButton = forwardRef<
  HTMLButtonElement,
  ChatbotFloatingButtonProps
>(({ onClick, isOpen }, ref) => {
  return (
    <button
    id='ask-compass-button'
      ref={ref}
      onClick={onClick}
      data-chatbot-button
      className={`fixed bottom-10 left-20 walkthrough-chatbot-button ${
        isOpen ? 'p-3' : 'py-3 px-4'
      } bg-black dark:bg-gray-900 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center gap-2 z-[99]`}
    >
      {isOpen ? (
        <img src={WhiteCloseIcon} alt='Close' className='w-6 h-6' />
      ) : (
        <>
          <img src={MagicButtonIcon} alt='Ask Compass' className='w-6 h-6' />
          <span
            className='text-white text-lg font-semibold'
          >
            Ask Compass
          </span>
        </>
      )}
    </button>
  );
});

ChatbotFloatingButton.displayName = 'ChatbotFloatingButton';

export default ChatbotFloatingButton;
